import React from 'react';
import classnames from 'classnames';

import Days from './MonthView/Days';
import Weekdays from './MonthView/Weekdays';
import WeekNumbers from './MonthView/WeekNumbers';

type MonthViewProps = {
	showWeekNumbers?: boolean;
} & React.ComponentProps<typeof Weekdays> &
	React.ComponentProps<typeof WeekNumbers> &
	React.ComponentProps<typeof Days>;

const MonthView: React.FC<MonthViewProps> = function MonthView(props) {
	const { activeStartDate, locale, onMouseLeave, showFixedNumberOfWeeks } = props;
	const { formatShortWeekday, formatWeekday, onClickWeekNumber, showWeekNumbers, ...childProps } =
		props;

	function renderWeekdays() {
		return (
			<Weekdays
				formatShortWeekday={formatShortWeekday}
				formatWeekday={formatWeekday}
				locale={locale}
				onMouseLeave={onMouseLeave}
			/>
		);
	}

	function renderWeekNumbers() {
		if (!showWeekNumbers) {
			return null;
		}

		return (
			<WeekNumbers
				activeStartDate={activeStartDate}
				onClickWeekNumber={onClickWeekNumber}
				onMouseLeave={onMouseLeave}
				showFixedNumberOfWeeks={showFixedNumberOfWeeks}
			/>
		);
	}

	function renderDays() {
		return <Days {...childProps} />;
	}

	const className = 'FSHCalendarView__month-view';

	return (
		<div className={classnames(className, showWeekNumbers ? `${className}--weekNumbers` : '')}>
			<div
				style={{
					display: 'flex',
					alignItems: 'flex-end',
				}}
			>
				{renderWeekNumbers()}
				<div
					style={{
						flexGrow: 1,
						width: '100%',
					}}
				>
					{renderWeekdays()}
					{renderDays()}
				</div>
			</div>
		</div>
	);
};

export default MonthView;
